var CoinCardAPI = {
  
  /**
   * @param {String} email
   * @param {String} coincard
   * @returns {jqXHR} - XMLHTTPRequest object
   */
  getCustomerProfile: ({ email, coincard }) => {

    return $.post({ 
      url: window.CoinCard.getCustomerProfileURL,
      data: JSON.stringify({ email, coincard }),
      dataType: 'json',
      contentType: 'application/json'
    });
    
  },

  /**
   * @param {String} email
   * @returns {jqXHR} - XMLHTTPRequest object
   */
  checkEmailForAssociation: ({ email }) => {

    return $.post({
      url: window.CoinCard.checkEmailForAssociation,
      data: JSON.stringify({ email }),
      dataType: 'json',
      contentType: 'application/json'
    });
    
  }

}
module.exports = CoinCardAPI;